import { get, call } from 'vuex-pathify';
export default {
  computed: {
    dmaDataSourceName: get('admin/modulesMapping@billing.dma_datasource_name'),
    dmaLayerId: get('admin/modulesMapping@billing.dma_layer_id'),
    watermetersDatasourceName: get('admin/modulesMapping@billing.watermeters_datasource_name'),
    layers: get('layers/layers'),
    datasources: get('layers/metadata'),
  },
  methods: {
    editNonTopoFeatureAction: call('layers/editDatasourceFeature'),
    editTopoFeatureAction: call('layers/editTopoDatasourceFeature'),
    isTopologicalDataSource({ name: dataSourceName, scope: dataSourceScope } = {}) {
      return (
        (dataSourceScope === 'water' || dataSourceScope === 'sewer') &&
        (!this.dmaDataSourceName || dataSourceName !== this.dmaDataSourceName) &&
        (!this.watermetersDatasourceName || dataSourceName !== this.watermetersDatasourceName)
      );
    },
    isTopologicalLayer({ id: layerId, layer_scope: layerScope } = {}) {
      return (
        (layerScope === 'water' || layerScope === 'sewer') &&
        (!this.dmaLayerId || layerId !== this.dmaLayerId) &&
        (!this.watermetersDatasourceName || this.layers[layerId]?.data_source_name !== this.watermetersDatasourceName)
      );
    },
    /** Provide { params: { layer_id: <id> }} to check layer's topology instead of datasource  */
    topoAwareEditFeatureAction(payload) {
      const isTopo = payload.params?.layer_id
        ? this.isTopologicalLayer({
            id: payload.params?.layer_id,
            layer_scope: this.layers[payload.params?.layer_id]?.scope,
          })
        : this.isTopologicalDataSource({
            name: payload.datasource,
            scope: this.datasources[payload.datasource]?.scope,
          });
      return isTopo ? this.editTopoFeatureAction(payload) : this.editNonTopoFeatureAction(payload);
    },
  },
};
